import { EasyField } from '../baseClasses/easyField';
import { FieldOptions } from '../index';

export class EasyDividerField extends EasyField {
    controlType = 'divider';

    constructor(options: FieldOptions<any> = {}) {
        super(options);
        options.controlType = this.controlType;
    }
}
